__turbopack_context__.v({
  "actionIcon": "dashboard-module__Gx_nyq__actionIcon",
  "adminOrderForm": "dashboard-module__Gx_nyq__adminOrderForm",
  "brand": "dashboard-module__Gx_nyq__brand",
  "button": "dashboard-module__Gx_nyq__button",
  "conversation": "dashboard-module__Gx_nyq__conversation",
  "conversationTitle": "dashboard-module__Gx_nyq__conversationTitle",
  "customerList": "dashboard-module__Gx_nyq__customerList",
  "customerOption": "dashboard-module__Gx_nyq__customerOption",
  "customerSearch": "dashboard-module__Gx_nyq__customerSearch",
  "customerSelected": "dashboard-module__Gx_nyq__customerSelected",
  "error": "dashboard-module__Gx_nyq__error",
  "full": "dashboard-module__Gx_nyq__full",
  "header": "dashboard-module__Gx_nyq__header",
  "headerActions": "dashboard-module__Gx_nyq__headerActions",
  "inlineForm": "dashboard-module__Gx_nyq__inlineForm",
  "list": "dashboard-module__Gx_nyq__list",
  "messageForm": "dashboard-module__Gx_nyq__messageForm",
  "notice": "dashboard-module__Gx_nyq__notice",
  "order": "dashboard-module__Gx_nyq__order",
  "orderHead": "dashboard-module__Gx_nyq__orderHead",
  "page": "dashboard-module__Gx_nyq__page",
  "panel": "dashboard-module__Gx_nyq__panel",
  "panelToolbar": "dashboard-module__Gx_nyq__panelToolbar",
  "productForm": "dashboard-module__Gx_nyq__productForm",
  "reviewForm": "dashboard-module__Gx_nyq__reviewForm",
  "secondary": "dashboard-module__Gx_nyq__secondary",
  "shipment": "dashboard-module__Gx_nyq__shipment",
});
